
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProductsSection from './components/ProductsSection';
import AboutSection from './components/AboutSection';
import PartnersSection from './components/PartnersSection';
import ContactSection from './components/ContactSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Cobra Sécurité - Solutions de Sécurité Professionnelles Tunisie';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Cobra Sécurité - Spécialiste en vidéo surveillance, détection incendie, contrôle d\'accès et systèmes anti-intrusion en Tunisie. Devis gratuit et installation professionnelle par nos experts.');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Cobra Sécurité",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "logo": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`,
      "description": "Spécialiste en solutions de sécurité professionnelles en Tunisie",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "TN",
        "addressRegion": "Tunis"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+216-XX-XXX-XXX",
        "contactType": "customer service",
        "email": "cobra@cobrasecurite.com.tn"
      },
      "sameAs": [
        "https://www.facebook.com/cobrasecurite",
        "https://www.linkedin.com/company/cobrasecurite"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de Sécurité",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vidéosurveillance",
              "description": "Installation et maintenance de systèmes de vidéosurveillance"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Contrôle d'accès",
              "description": "Systèmes de contrôle d'accès et gestion des entrées"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Détection incendie",
              "description": "Systèmes de détection et alarme incendie"
            }
          }
        ]
      }
    });
    
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <section>
          <h1 style={{ position: 'absolute', left: '-9999px' }}>Cobra Sécurité - Solutions de Sécurité Professionnelles</h1>
        </section>
        <HeroSection />
        <ServicesSection />
        <ProductsSection />
        <AboutSection />
        <PartnersSection />
        <ContactSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
